import { useEffect, useState } from 'react';
import { Modal } from '../../../theme/Component/Modal';
import { SiteID } from './SiteID';
import { toast } from 'react-toastify';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _SiteID } from '../../../../core/services/dataBean/EntityCatalog';
import { SelectCountries } from '../Countries/SelectCountries';



interface Props {
    onChange: any;
    idLnSite?: number;
    edit: boolean;
    label?: string;
    multiSelect?: boolean;
}

export const SelectSiteID = ({ edit, onChange, label, multiSelect, idLnSite }: Props) => {

    const { instance } = useDataBean(_SiteID)

    const [modal, setModal] = useState<any>({ name: 'Ciudades', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [valor, setValor] = useState('');
    const [multiValue, setMultivalue] = useState<any>([]);
    const [multiNames, setMultiNames] = useState<string[]>([]);

    //nota de el mejor para los demas:
    //si el multiselect viene activo, el componente devolvera una lista,de objetos para su uso e iteracion de esta misma en el componente padre donde se esta invocando...

    useEffect(() => {
        if (idLnSite) {
            getSite();
        }
    }, [idLnSite])

    const getSite = () => {
        instance.getSiteIDByKey(idLnSite, null).then(
            (resp) => {
                //console.log(resp);
                setValor(`${resp.Code ?? ""} - ${resp.Name ?? ""}`)
                onChange(resp)
            }
        ).catch(
            err => {
                console.error(err);
            }
        )
    };

    const getItem = () => {
        let bean: any = JSON.parse(localStorage.getItem('SiteID') || '{}');


        if (multiSelect) {
            const exists = multiValue.some((item: any) => item.IDLn === bean.IDLn);
            if (!exists) {
                const updatedMultiValue = [...multiValue, bean];
                setMultivalue(updatedMultiValue);
                onChange(updatedMultiValue);

                const updatedMultiNames = updatedMultiValue.map((item: any) => item.Name);
                setMultiNames(updatedMultiNames);
            } else {
                toast.error("Ya se Encuentra Seleccionado")
            }
        } else {
            onChange(bean);
            setValor(bean.Codde + " " + bean.Name);
        }

        setModal({ ...modal, "view": false });
    };

    const removeItem = (index: number) => {
        const updatedMultiValue = [...multiValue];
        updatedMultiValue.splice(index, 1);
        setMultivalue(updatedMultiValue);
        onChange(updatedMultiValue);

        const updatedMultiNames = updatedMultiValue.map((item: any) => item.Name);
        setMultiNames(updatedMultiNames);
    };

    return (
        <>

            {label ?
                <label className={`${label === " " ? "d-none" : " "}`}>{label}</label>
                :
                <label>Ciudad</label>
            }
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true })}>
                {multiSelect ? (
                    multiNames.length > 0 ? (
                        multiNames.map((name, index) => (
                            <span key={index} className="badge m-1 btn btn-primary">
                                {name}
                                <button
                                    type="button"
                                    className="btn btn-sm btn-danger ms-2"
                                    style={{ marginLeft: '8px' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        removeItem(index);
                                    }}
                                >
                                    &times;
                                </button>
                            </span>
                        ))
                    ) : (
                        <span>Seleccionar...</span>
                    )
                ) : valor ? (
                    valor
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            {modal.view &&
                <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={getItem}>
                    <div style={{ maxHeight: '60vh', overflow: 'auto' }}>
                        <SiteID id={null} edit={false} />

                    </div>
                </Modal>
            }
        </>
    )
}